import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const envelope: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M14-6.453V-.25q0 .514-.375.875A1.17 1.17 0 0 1 12.75 1H1.25Q.735 1 .36.625A1.19 1.19 0 0 1 0-.25v-6.203q.34.377.797.672Q3.623-3.86 4.672-3.078q.45.328.719.516.28.176.734.375Q6.593-2 7-2h.016q.386 0 .843-.187.47-.2.75-.375.28-.187.72-.516 1.323-.968 3.89-2.703.451-.295.781-.672m0-2.297c0 .406-.133.797-.39 1.172q-.375.564-.938.969Q9.73-4.576 9.016-4.08q-.081.065-.344.25-.252.176-.422.298a5 5 0 0 1-.406.25 2.5 2.5 0 0 1-.453.219A1.3 1.3 0 0 1 7.016-3H7a1.4 1.4 0 0 1-.406-.062 2.7 2.7 0 0 1-.438-.22q-.235-.138-.406-.25-.176-.121-.422-.296A9 9 0 0 1 5-4.078L2.938-5.5q-1.33-.92-1.594-1.11a3.9 3.9 0 0 1-.922-.906Q0-8.09 0-8.578c0-.406.11-.742.328-1.016q.327-.405.922-.406h11.5q.514 0 .875.375.375.361.375.875m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 10)"
    />
  ),
  svgProps: {
    height: "11",
    width: "14",
  }
};